// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"e1305fb2","205":"44607cff","231":"2b35ae17","760":"be959309"}[chunkId] + ".chunk.js";
};